import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const apiUrl = process.env.REACT_APP_API_URL;

function DailyUpdate() {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [data, setData] = useState([]);
  const [dataScreen, setDataScreen] = useState([]);
  const [dataEthio, setDataEthio] = useState([]);

  const [rateDaily, setRateDaily] = useState(0);
  const [profit, setProfit] = useState(0);

  const copyToClipboard = () => {
    const rows = data.map((item) => {
      const storage = item.storage.replace("GB", "").trim();

      const simRaw = item.sim.toLowerCase();
      const sim = simRaw.includes("esim")
        ? "e"
        : simRaw.includes("dual")
          ? "d"
          : simRaw.includes("single")
            ? "s"
            : simRaw[0]; // fallback to first letter

      const rawPrice =
        Math.ceil(
          ((item.price + item.com1 + item.com2 + item.deliveryFee) * rateDaily +
            2000 +
            profit) /
          500
        ) * 500;
      const soldPrice = Math.ceil(rawPrice / 100) * 100;

      return `${item.model} ${storage} ${sim} ${soldPrice}`;
    });

    const fullText = rows.join("\n");

    navigator.clipboard
      .writeText(fullText)
      .then(() => alert("Copied to clipboard!"))
      .catch(() => alert("Failed to copy."));
  };

  const copyToClipboardEthio = () => {
    const rows = dataEthio.map((item) => {
      const storage = item.storage.replace("GB", "").trim();

      const simRaw = item.sim.toLowerCase();
      const sim = simRaw.includes("esim")
        ? "e"
        : simRaw.includes("dual")
          ? "d"
          : simRaw.includes("single")
            ? "s"
            : simRaw[0]; // fallback to first letter

      const rawPrice = Math.ceil((item.price + profit) / 500) * 500;
      const soldPrice = Math.ceil(rawPrice / 100) * 100;

      return `${item.model} ${storage} ${sim} ${soldPrice}`;
    });

    const fullText = rows.join("\n");

    navigator.clipboard
      .writeText(fullText)
      .then(() => alert("Copied to clipboard!"))
      .catch(() => alert("Failed to copy."));
  };

  const copyToClipboardScreen = () => {
    const rows = dataScreen.map((item) => {
      const rawPrice =
        Math.ceil(((item.price + 30) * rateDaily + 1000 + profit) / 500) * 500;
      const soldPrice = Math.ceil(rawPrice / 100) * 100;
      return `${item.model} ${item.frame} --- ${soldPrice}`;
    });

    const fullText = rows.join("\n");

    navigator.clipboard
      .writeText(fullText)
      .then(() => alert("Copied to clipboard!"))
      .catch(() => alert("Failed to copy."));
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/sortedItems`);
      const responseRate = await axios.get(`${apiUrl}/dailyRate`);
      const fetchedData = response.data.map((item) => ({
        model: item.Model.trim().toLowerCase(),
        storage: item.Storage.trim(),
        sim: item.Sim.trim().toLowerCase(),
        com1: Number(item.com1 || 70),
        com2: Number(item.com2 || 40),
        deliveryFee: Number(item.DeliveryFee || 10),
        price: Number(item.Price),
      }));

      const grouped = new Map();

      fetchedData.forEach((item) => {
        const key = `${item.model}-${item.storage}-${item.sim}-${item.price}`;
        const existing = grouped.get(key);

        if (!existing) {
          grouped.set(key, { ...item, count: 1 });
        } else {
          // Increment count
          existing.count += 1;

          // Keep item with the higher price
          if (item.price > existing.price) {
            existing.price = item.price;
          }

          grouped.set(key, existing);
        }
      });

      const filteredData = Array.from(grouped.values()).sort((a, b) =>
        a.model.localeCompare(b.model)
      );
      setRateDaily(
        responseRate.data.length > 0 ? responseRate.data[0].rate : 0
      );

      setData(filteredData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const fetchDataScreen = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/sortedItemscreen`);
      const fetchedData = response.data.map((item) => ({
        model: item.ItemName.trim().toLowerCase(),
        frame: item.frame.trim().toLowerCase(),
        price: Number(item.price),
      }));

      const grouped = new Map();

      fetchedData.forEach((item) => {
        const key = `${item.model}-${item.frame}`;
        const existing = grouped.get(key);

        if (!existing) {
          grouped.set(key, { ...item, count: 1 });
        } else {
          // Increment count
          existing.count += 1;

          // Keep item with the higher price
          if (item.price > existing.price) {
            existing.price = item.price;
          }

          grouped.set(key, existing);
        }
      });

      const filteredData = Array.from(grouped.values()).sort((a, b) =>
        a.model.localeCompare(b.model)
      );
      setDataScreen(filteredData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const fetchDataEthio = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/sortedItemEthio`);
      const fetchedData = response.data.map((item) => ({
        model: item.Model.trim().toLowerCase(),
        storage: item.Storage.trim(),
        sim: item.Sim.trim().toLowerCase(),
        price: Number(item.Price),
      }));
      const grouped = new Map();

      fetchedData.forEach((item) => {
        const key = `${item.model}-${item.storage}-${item.sim}`;
        const existing = grouped.get(key);

        if (!existing) {
          grouped.set(key, { ...item, count: 1 });
        } else {
          // Increment count
          existing.count += 1;

          // Keep item with the higher price
          if (item.Price > existing.Price) {
            existing.price = item.Price;
          }

          grouped.set(key, existing);
        }
      });

      const filteredData = Array.from(grouped.values()).sort((a, b) =>
        a.model.localeCompare(b.model)
      );
      setDataEthio(filteredData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const fetchOtherItems = async () => {
    try {
      const response = await axios.get(`${apiUrl}/otherItems`);
      const grouped = {};

      response.data.forEach((item) => {
        const key = `${item.Model}-${item.deliveryFee}-${item.carrier}-${item.price}`;
        if (!grouped[key]) {
          grouped[key] = { ...item, count: 1 };
        } else {
          grouped[key].count++;
        }
      });
    } catch (err) {
      setErrors("Failed to load other items.");
    }
  };

  const totalPrice = () => {
    let sum = 0;

    data.forEach((item) => {
      const price = Number(item.Price) || 0;
      const com1 = Number(item.com1) || 0;
      const com2 = Number(item.com2) || 0;
      const deliveryFee = Number(item.DeliveryFee) || 0;
      sum = price + com1 + com2 + deliveryFee;
    });

    return sum;
  };

  useEffect(() => {
    fetchData();
    fetchOtherItems();
    fetchDataScreen();
    fetchDataEthio();
    totalPrice();
  }, []);

  const updateRate = async () => {
    try {
      const response = await fetch(`${apiUrl}/dailyRate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ rateDaily }),
      });
      if (!response.ok) throw new Error("Network response was not ok");
      toast.success("Daily Rate Updated Successfully!");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="items-center flex flex-col justify-center mt-5 overflow-auto">
      <div className="mt-20 w-3/4 px-5 rounded-md overflow-auto justify-start">
        <h1 className="font-bold text-2xl mb-4">Daily Rate Update</h1>
        <div className="relative">
          <label
            htmlFor="brand"
            className="absolute left-3 bg-white px-2 font text-gray-400"
            style={{ top: "-12px" }}
          >
            Daily Rate
          </label>
          <input
            id="brand"
            className="p-2 bg-gray-200 rounded-md"
            placeholder="Todays Rate"
            onChange={(e) => setRateDaily(e.target.value)}
          />
          <button
            className="ml-4 rounded-md py-2 px-4 bg-blue-700 shadow-md"
            onClick={() => updateRate()}
          >
            Update
          </button>
        </div>
      </div>
      <div className="border-1 border-slate-200 mt-20 w-3/4 mb-20 px-5 rounded-md overflow-auto justify-center align-middle">
        <h1 className="font-bold text-2xl">Phone Models</h1>
        <p className="font-bold text-xl">Model Counts</p>
        <input
          className="p-2 bg-gray-200 "
          placeholder="Rate"
          value={rateDaily}
          onChange={(e) => setRateDaily(e.target.value)}
        />
        <input
          className="p-2 bg-red-200 ml-4"
          placeholder="Profit"
          value={profit}
          onChange={(e) => setProfit(Number(e.target.value))}
        />
        <button
          onClick={copyToClipboard}
          className="bg-blue-500 text-white ml-4 px-4 py-2 rounded hover:bg-blue-600 mb-4"
        >
          Copy
        </button>
        <button
          onClick={copyToClipboardScreen}
          className="bg-green-500 text-white ml-4 px-4 py-2 rounded hover:bg-blue-600 mb-4"
        >
          Copy Screen
        </button>
        <button
          onClick={copyToClipboardEthio}
          className="bg-red-500 text-white ml-4 px-4 py-2 rounded hover:bg-blue-600 mb-4"
        >
          Copy Ethio
        </button>

        <table className="border-collapse table-auto w-full mb-10 overflow-x-scroll">
          <thead>
            <tr>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Model
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Storage
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Sim
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Price
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Sold
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Count
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Subtotal
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => {
              const soldPrice = Math.ceil(
                ((item.price + item.com1 + item.com2 + item.deliveryFee) *
                  rateDaily +
                  2000 +
                  profit) /
                500
              ) * 500;
              return (
                <tr key={index}>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {item.model}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {item.storage}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {item.sim}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {item.price}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {soldPrice}
                  </td>

                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {item.count}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left font-medium">
                    {(soldPrice * item.count).toLocaleString()}
                  </td>
                </tr>
              );
            })}
            <tr>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                Total
              </td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left"></td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left"></td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                {data.reduce((sum, item) => sum + (Number(item.price) || 0), 0).toLocaleString()}
              </td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left"></td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                {data.reduce((total, item) => total + item.count, 0)}
              </td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                {data.reduce((sum, item) => {
                  const soldPrice = Math.ceil(
                    ((item.price + item.com1 + item.com2 + item.deliveryFee) *
                      rateDaily +
                      2000 +
                      profit) /
                    500
                  ) * 500;
                  return sum + soldPrice * item.count;
                }, 0).toLocaleString()}
              </td>
            </tr>
          </tbody>
        </table>
        <h2 className="font-bold text-xl">Screen Models</h2>
        <table className="border-collapse table-auto w-full mb-10 overflow-x-scroll">
          <thead>
            <tr>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                ItemName
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Frame
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Price
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Sold
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Count
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Subtotal
              </th>
            </tr>
          </thead>
          <tbody>
            {dataScreen.map((item, index) => {
              const soldPrice = Math.ceil(
                ((item.price + 30) * rateDaily + 1000 + profit) / 500
              ) * 500;
              return (
                <tr key={index}>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {item.model}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {item.frame}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {item.price}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {soldPrice}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {item.count}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left font-medium">
                    {(soldPrice * item.count).toLocaleString()}
                  </td>
                </tr>
              );
            })}
            <tr>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                Total
              </td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left"></td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                {dataScreen.reduce((sum, item) => sum + (Number(item.price) || 0), 0).toLocaleString()}
              </td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left"></td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                {dataScreen.reduce((total, item) => total + item.count, 0)}
              </td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                {dataScreen.reduce((sum, item) => {
                  const soldPrice = Math.ceil(
                    ((item.price + 30) * rateDaily + 1000 + profit) / 500
                  ) * 500;
                  return sum + soldPrice * item.count;
                }, 0).toLocaleString()}
              </td>
            </tr>
          </tbody>
        </table>
        <h2 className="font-bold text-xl">Ethio Products</h2>
        <table className="border-collapse table-auto w-full mb-10 overflow-x-scroll">
          <thead>
            <tr>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Model
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Storage
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Sim
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Price
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Sold
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Count
              </th>
              <th className="border-b-1 pb-3 border-slate-600 text-left">
                Subtotal
              </th>
            </tr>
          </thead>
          <tbody>
            {dataEthio.map((item, index) => {
              const soldPrice = Math.ceil((item.price + profit) / 500) * 500;
              return (
                <tr key={index}>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {item.model}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {item.storage}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {item.sim}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {item.price}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {soldPrice}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left">
                    {item.count}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left font-medium">
                    {(soldPrice * item.count).toLocaleString()}
                  </td>
                </tr>
              );
            })}
            <tr>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                Total
              </td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left"></td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left"></td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                {dataEthio.reduce((sum, item) => sum + (Number(item.price) || 0), 0).toLocaleString()}
              </td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left"></td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                {dataEthio.reduce((total, item) => total + item.count, 0)}
              </td>
              <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                {dataEthio.reduce((sum, item) => {
                  const soldPrice = Math.ceil((item.price + profit) / 500) * 500;
                  return sum + soldPrice * item.count;
                }, 0).toLocaleString()}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DailyUpdate;
